<template>
  <div>
    <Banner />
    <div v-lazy-container="{ selector: 'span' }">
      <template v-for="(component, i) in data.components">
        <span :key="i">
          <component
            :key="i"
            v-bind:is="component.name"
            :id="component.name"
          ></component>
        </span>
      </template>
    </div>
  </div>
</template>

<script>
import Constants from "../../constants/Constants";
import Banner from "../Banner";

const ViewComponents = Constants.APPLICATION.VIEW_COMPONENTS;

let components = { Banner };

ViewComponents.forEach((component) => {
  components[component.name] = () => loadComponent(component.name);
});

function loadComponent(filename) {
  return import(`../${filename}.vue`);
}
export default {
  name: "Views",
  components: components,
  data() {
    return {
      data: {
        components: ViewComponents,
        isActive: false,
      },
    };
  },
};
</script>
